import { create } from "zustand";
import { persist } from "zustand/middleware";

export const usePropertyStore = create(
    persist(
        (set, get) => ({
            properties: [],
            simpleFilter: {
                property_type: "",
                province: "",
                city: "",
            },
            advancedFilter: {
                search: "",
                types: [],
                harga: [],
                provinces: [],
                cities: [],
                sort: "default",
                page: 1,
                perPage: 6,
            },

            direct: false,

            detailProperti: null,

            // ACTION
            setProperties: (data) => set({ properties: data }),

            setSimpleFilter: (key, value) =>
                set((state) => ({
                    simpleFilter: { ...state.simpleFilter, [key]: value },
                })),

            applySimpleFilter: () => {
                set((state) => ({
                    advancedFilter: {
                        ...state.advancedFilter,
                        types: state.simpleFilter.property_type
                            ? [state.simpleFilter.property_type]
                            : [],
                    },
                }));
            },

            setAdvancedFilter: (key, value) =>
                set((state) => ({
                    advancedFilter: { ...state.advancedFilter, [key]: value },
                })),

            setDetailProperti: (property) => set({ detailProperti: property }),

            setDirect: (val) => set({direct: val})
        }),
        {
            name: "property-storage",
            partialize: (state) => ({
                simpleFilter: state.simpleFilter,
                advancedFilter: state.advancedFilter,
            }),
        }
    )
);
